import React from "react";
import Logo from "../images/logo";

export default (props: { onClick: Function }) => (
  <div className={"logoBar"} onClick={() => props.onClick()}>
    <Logo />
    <span>
      Opteon™ XL Very Low GWP A2L Refrigerants:
      <br />
      Long-term, Sustainable Solutions
    </span>
  </div>
);
